import React from 'react';
import { ParkingPermissionCheckResult } from 'src/pages/Suite/Components/UnitImportDialogue/Hooks/Helpers/rowValidationHelpers';
import './ParkingPermissionErrorCard.scss';

interface ParkingPermissionErrorCardProps {
  permissionError: ParkingPermissionCheckResult;
}

const ParkingPermissionErrorCard = ({
  permissionError,
}: ParkingPermissionErrorCardProps) => {
  const unitCount: number =
    permissionError.unitNumbersWithParkingOrStorage.length;

  return (
    <div className="parking-permission-card">
      <div className="parking-permission-card-header">
        <div className="parking-permission-card-title">
          {unitCount} unit{unitCount !== 1 ? 's' : ''} in your CSV include
          parking stalls or storage lockers, but this property doesn't have the
          "Parking Details" permission enabled
        </div>
        <div className="parking-permission-card-subtitle">
          Without this permission, imported parking and storage data is saved
          but hidden everywhere in Juniper. Open Edit Property, enable "Parking
          Details" under Permissions, then re-upload your CSV.
        </div>
      </div>
      <div className="parking-permission-card-body">
        <div className="parking-permission-card-label">
          Units with parking or storage data
        </div>
        <div className="parking-permission-chip-list">
          {permissionError.unitNumbersWithParkingOrStorage.map(
            (unitNumber: string) => (
              <span key={unitNumber} className="parking-permission-chip">
                {unitNumber}
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ParkingPermissionErrorCard;